import { render, staticRenderFns } from "./SelectOrderBy.vue?vue&type=template&id=62680874&scoped=true"
import script from "./SelectOrderBy.vue?vue&type=script&lang=js"
export * from "./SelectOrderBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62680874",
  null
  
)

export default component.exports